const toPositiveNumber = (value, fallback = 1) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) && numberValue > 0 ? numberValue : fallback;
};

const roundCurrencyAmount = (amount) => Math.round(Number(amount || 0) * 100) / 100;

export const resolveConvertedUnitPrice = ({
  currentUnitPrice,
  savedBasePrice,
  oldRate,
  newRate,
  newCurrencyCode,
}) => {
  const currentPrice = Number(currentUnitPrice || 0);
  const normalizedOldRate = toPositiveNumber(oldRate);
  const normalizedNewRate = toPositiveNumber(newRate);
  const basePrice = Number(savedBasePrice);
  const hasUsableSavedBasePrice = Number.isFinite(basePrice) && basePrice > 0;
  const baseUnitPrice = hasUsableSavedBasePrice
    ? basePrice
    : currentPrice * normalizedOldRate;
  const convertedUnitPrice = String(newCurrencyCode || '').toUpperCase() === 'IDR'
    ? baseUnitPrice
    : baseUnitPrice / normalizedNewRate;

  return {
    exchangeRate: normalizedNewRate,
    unitPrice: roundCurrencyAmount(convertedUnitPrice),
    unitPriceDisplayCurrency: roundCurrencyAmount(convertedUnitPrice),
    unitPriceBaseCurrency: baseUnitPrice,
  };
};
